// Generated by tools/as3-to-ts from work/decomp/main/scripts/com/adobe/crypto/MD5.as; hand-edits allowed (see docs/architecture.md)

import * as as3 from '../../../runtime/as3';
import { IntUtil } from '../../../com/adobe/utils/IntUtil';

export class MD5 {
  static digest: any = null;

  constructor() {
  }

  static hash(param1: any): any {
    param1 = as3.str(param1);
    // PORT: ByteArray.writeUTFBytes replaced by a plain UTF-8 byte array (hashBinary/createBlocks only read length and [i]).
    let _loc2_: any = as3.utf8Bytes(param1);
    return MD5.hashBinary(_loc2_);
  }

  static hashBytes(param1: any): any {
    return MD5.hashBinary(param1);
  }

  static hashBinary(param1: any): any {
    let _loc6_: number = 0;
    let _loc7_: number = 0;
    let _loc8_: number = 0;
    let _loc9_: number = 0;
    let _loc2_: number = 1732584193;
    let _loc3_: number = -271733879;
    let _loc4_: number = -1732584194;
    let _loc5_: number = 271733878;
    let _loc10_: any = MD5.createBlocks(param1);
    let _loc11_: number = as3.int(_loc10_.length);
    let _loc12_: number = 0;
    while (_loc12_ < _loc11_) {
      _loc6_ = _loc2_;
      _loc7_ = _loc3_;
      _loc8_ = _loc4_;
      _loc9_ = _loc5_;
      _loc2_ = as3.int(MD5.ff(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 0)], 7, -680876936));
      _loc5_ = as3.int(MD5.ff(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 1)], 12, -389564586));
      _loc4_ = as3.int(MD5.ff(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 2)], 17, 606105819));
      _loc3_ = as3.int(MD5.ff(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 3)], 22, -1044525330));
      _loc2_ = as3.int(MD5.ff(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 4)], 7, -176418897));
      _loc5_ = as3.int(MD5.ff(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 5)], 12, 1200080426));
      _loc4_ = as3.int(MD5.ff(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 6)], 17, -1473231341));
      _loc3_ = as3.int(MD5.ff(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 7)], 22, -45705983));
      _loc2_ = as3.int(MD5.ff(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 8)], 7, 1770035416));
      _loc5_ = as3.int(MD5.ff(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 9)], 12, -1958414417));
      _loc4_ = as3.int(MD5.ff(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 10)], 17, -42063));
      _loc3_ = as3.int(MD5.ff(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 11)], 22, -1990404162));
      _loc2_ = as3.int(MD5.ff(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 12)], 7, 1804603682));
      _loc5_ = as3.int(MD5.ff(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 13)], 12, -40341101));
      _loc4_ = as3.int(MD5.ff(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 14)], 17, -1502002290));
      _loc3_ = as3.int(MD5.ff(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 15)], 22, 1236535329));
      _loc2_ = as3.int(MD5.gg(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 1)], 5, -165796510));
      _loc5_ = as3.int(MD5.gg(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 6)], 9, -1069501632));
      _loc4_ = as3.int(MD5.gg(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 11)], 14, 643717713));
      _loc3_ = as3.int(MD5.gg(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 0)], 20, -373897302));
      _loc2_ = as3.int(MD5.gg(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 5)], 5, -701558691));
      _loc5_ = as3.int(MD5.gg(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 10)], 9, 38016083));
      _loc4_ = as3.int(MD5.gg(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 15)], 14, -660478335));
      _loc3_ = as3.int(MD5.gg(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 4)], 20, -405537848));
      _loc2_ = as3.int(MD5.gg(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 9)], 5, 568446438));
      _loc5_ = as3.int(MD5.gg(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 14)], 9, -1019803690));
      _loc4_ = as3.int(MD5.gg(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 3)], 14, -187363961));
      _loc3_ = as3.int(MD5.gg(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 8)], 20, 1163531501));
      _loc2_ = as3.int(MD5.gg(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 13)], 5, -1444681467));
      _loc5_ = as3.int(MD5.gg(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 2)], 9, -51403784));
      _loc4_ = as3.int(MD5.gg(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 7)], 14, 1735328473));
      _loc3_ = as3.int(MD5.gg(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 12)], 20, -1926607734));
      _loc2_ = as3.int(MD5.hh(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 5)], 4, -378558));
      _loc5_ = as3.int(MD5.hh(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 8)], 11, -2022574463));
      _loc4_ = as3.int(MD5.hh(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 11)], 16, 1839030562));
      _loc3_ = as3.int(MD5.hh(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 14)], 23, -35309556));
      _loc2_ = as3.int(MD5.hh(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 1)], 4, -1530992060));
      _loc5_ = as3.int(MD5.hh(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 4)], 11, 1272893353));
      _loc4_ = as3.int(MD5.hh(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 7)], 16, -155497632));
      _loc3_ = as3.int(MD5.hh(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 10)], 23, -1094730640));
      _loc2_ = as3.int(MD5.hh(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 13)], 4, 681279174));
      _loc5_ = as3.int(MD5.hh(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 0)], 11, -358537222));
      _loc4_ = as3.int(MD5.hh(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 3)], 16, -722521979));
      _loc3_ = as3.int(MD5.hh(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 6)], 23, 76029189));
      _loc2_ = as3.int(MD5.hh(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 9)], 4, -640364487));
      _loc5_ = as3.int(MD5.hh(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 12)], 11, -421815835));
      _loc4_ = as3.int(MD5.hh(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 15)], 16, 530742520));
      _loc3_ = as3.int(MD5.hh(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 2)], 23, -995338651));
      _loc2_ = as3.int(MD5.ii(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 0)], 6, -198630844));
      _loc5_ = as3.int(MD5.ii(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 7)], 10, 1126891415));
      _loc4_ = as3.int(MD5.ii(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 14)], 15, -1416354905));
      _loc3_ = as3.int(MD5.ii(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 5)], 21, -57434055));
      _loc2_ = as3.int(MD5.ii(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 12)], 6, 1700485571));
      _loc5_ = as3.int(MD5.ii(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 3)], 10, -1894986606));
      _loc4_ = as3.int(MD5.ii(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 10)], 15, -1051523));
      _loc3_ = as3.int(MD5.ii(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 1)], 21, -2054922799));
      _loc2_ = as3.int(MD5.ii(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 8)], 6, 1873313359));
      _loc5_ = as3.int(MD5.ii(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 15)], 10, -30611744));
      _loc4_ = as3.int(MD5.ii(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 6)], 15, -1560198380));
      _loc3_ = as3.int(MD5.ii(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 13)], 21, 1309151649));
      _loc2_ = as3.int(MD5.ii(_loc2_, _loc3_, _loc4_, _loc5_, _loc10_[as3.int(_loc12_ + 4)], 6, -145523070));
      _loc5_ = as3.int(MD5.ii(_loc5_, _loc2_, _loc3_, _loc4_, _loc10_[as3.int(_loc12_ + 11)], 10, -1120210379));
      _loc4_ = as3.int(MD5.ii(_loc4_, _loc5_, _loc2_, _loc3_, _loc10_[as3.int(_loc12_ + 2)], 15, 718787259));
      _loc3_ = as3.int(MD5.ii(_loc3_, _loc4_, _loc5_, _loc2_, _loc10_[as3.int(_loc12_ + 9)], 21, -343485551));
      _loc2_ = as3.int(_loc2_ + _loc6_);
      _loc3_ = as3.int(_loc3_ + _loc7_);
      _loc4_ = as3.int(_loc4_ + _loc8_);
      _loc5_ = as3.int(_loc5_ + _loc9_);
      _loc12_ = as3.int(_loc12_ + 16);
    }
    // PORT: digest was a ByteArray filled with writeInt x4 (big-endian); now the equivalent 16-byte array.
    MD5.digest = as3.int32BytesBE([_loc2_, _loc3_, _loc4_, _loc5_]);
    return IntUtil.toHex(_loc2_) + IntUtil.toHex(_loc3_) + IntUtil.toHex(_loc4_) + IntUtil.toHex(_loc5_);
  }

  private static f(param1: number, param2: number, param3: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    return param1 & param2 | ~param1 & param3;
  }

  private static g(param1: number, param2: number, param3: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    return param1 & param3 | param2 & ~param3;
  }

  private static h(param1: number, param2: number, param3: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    return param1 ^ param2 ^ param3;
  }

  private static i(param1: number, param2: number, param3: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    return param2 ^ (param1 | ~param3);
  }

  private static transform(param1: any, param2: number, param3: number, param4: number, param5: number, param6: number, param7: number, param8: number): number {
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    param4 = as3.int(param4);
    param5 = as3.int(param5);
    param6 = as3.int(param6);
    param7 = as3.int(param7);
    param8 = as3.int(param8);
    let _loc9_: number = as3.int(param2 + as3.int(param1(param3, param4, param5)) + param6 + param8);
    return as3.int(IntUtil.rol(_loc9_, param7) + param3);
  }

  private static ff(param1: number, param2: number, param3: number, param4: number, param5: number, param6: number, param7: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    param4 = as3.int(param4);
    param5 = as3.int(param5);
    param6 = as3.int(param6);
    param7 = as3.int(param7);
    return MD5.transform(MD5.f, param1, param2, param3, param4, param5, param6, param7);
  }

  private static gg(param1: number, param2: number, param3: number, param4: number, param5: number, param6: number, param7: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    param4 = as3.int(param4);
    param5 = as3.int(param5);
    param6 = as3.int(param6);
    param7 = as3.int(param7);
    return MD5.transform(MD5.g, param1, param2, param3, param4, param5, param6, param7);
  }

  private static hh(param1: number, param2: number, param3: number, param4: number, param5: number, param6: number, param7: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    param4 = as3.int(param4);
    param5 = as3.int(param5);
    param6 = as3.int(param6);
    param7 = as3.int(param7);
    return MD5.transform(MD5.h, param1, param2, param3, param4, param5, param6, param7);
  }

  private static ii(param1: number, param2: number, param3: number, param4: number, param5: number, param6: number, param7: number): number {
    param1 = as3.int(param1);
    param2 = as3.int(param2);
    param3 = as3.int(param3);
    param4 = as3.int(param4);
    param5 = as3.int(param5);
    param6 = as3.int(param6);
    param7 = as3.int(param7);
    return MD5.transform(MD5.i, param1, param2, param3, param4, param5, param6, param7);
  }

  private static createBlocks(param1: any): any {
    let _loc2_: any = new Array();
    let _loc3_: number = as3.int(param1.length * 8);
    let _loc4_: number = 255;
    let _loc5_: number = 0;
    while (_loc5_ < _loc3_) {
      _loc2_[as3.int(_loc5_ >> 5)] = _loc2_[as3.int(_loc5_ >> 5)] | (param1[_loc5_ / 8] & _loc4_) << _loc5_ % 32;
      _loc5_ = as3.int(_loc5_ + 8);
    }
    _loc2_[as3.int(_loc3_ >> 5)] = _loc2_[as3.int(_loc3_ >> 5)] | 128 << _loc3_ % 32;
    _loc2_[as3.int((_loc3_ + 64 >>> 9 << 4) + 14)] = _loc3_;
    return _loc2_;
  }
}
